const { Page } = require('./lib/cjs/page-legacy');

module.exports = Page;
// eslint-disable-next-line n/no-exports-assign
exports = module.exports;
exports.Page = Page;
